import { lazy } from 'react';

// Lazy load all job components for better performance and code splitting
export const JobStatusBadge = lazy(() =>
  import('./JobStatusBadge').then((module) => ({ default: module.JobStatusBadge }))
);

export const ScrapingStatusBadge = lazy(() =>
  import('./ScrapingStatusBadge').then((module) => ({ default: module.ScrapingStatusBadge }))
);

export const JobCard = lazy(() =>
  import('./JobCard').then((module) => ({ default: module.JobCard }))
);

export const JobFilterBar = lazy(() =>
  import('./JobFilterBar').then((module) => ({ default: module.JobFilterBar }))
);

export const JobsTable = lazy(() =>
  import('./JobsTable').then((module) => ({ default: module.JobsTable }))
);

export const JobForm = lazy(() =>
  import('./JobForm').then((module) => ({ default: module.JobForm }))
);

export const SkillsCombobox = lazy(() =>
  import('./SkillsCombobox').then((module) => ({ default: module.SkillsCombobox }))
);

export const SalaryRangeInput = lazy(() =>
  import('./SalaryRangeInput').then((module) => ({ default: module.SalaryRangeInput }))
);

export const SalaryRangeFilter = lazy(() =>
  import('./SalaryRangeFilter').then((module) => ({ default: module.SalaryRangeFilter }))
);

export const JobStatusUpdater = lazy(() =>
  import('./JobStatusUpdater').then((module) => ({ default: module.JobStatusUpdater }))
);

export const UrlScrapingSection = lazy(() =>
  import('./UrlScrapingSection').then((module) => ({ default: module.UrlScrapingSection }))
);

export const ScrapingQueueTable = lazy(() =>
  import('./ScrapingQueueTable').then((module) => ({ default: module.ScrapingQueueTable }))
);

export const ScrapingQueueStats = lazy(() =>
  import('./ScrapingQueueStats').then((module) => ({ default: module.ScrapingQueueStats }))
);

export const AddJobButton = lazy(() =>
  import('./AddJobButton').then((module) => ({ default: module.AddJobButton }))
);
